import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { AuthContext } from "../../context/Auth/AuthContext";

const TrialExpired = () => {
  const { handleLogout } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 3,
      }}
    >
      <Stack alignItems="center" spacing={3} sx={{ maxWidth: 420, textAlign: "center" }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            bgcolor: "error.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LockOutlined sx={{ fontSize: 36, color: "error.contrastText" }} />
        </Box>

        <Typography variant="h5" fontWeight={700}>
          Your trial has ended
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Your 7-day free trial has expired. Upgrade to continue using Hashlix CRM and keep access to all your tickets, contacts, and connections.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/billing")}
          sx={{ minWidth: 200 }}
        >
          Upgrade Now
        </Button>

        <Button variant="text" color="inherit" onClick={handleLogout} sx={{ color: "text.secondary" }}>
          Log out
        </Button>
      </Stack>
    </Box>
  );
};

export default TrialExpired;
